import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import NormalToggleWithText from '../Toggles/NormalToggleWithText';
import LockedToggleWithText from '../Toggles/LockedToggleWithText';
import FormItemSmall from '../FormItemSmall';
import FormLabel from '../FormLabel';

export default function ToggleSwitchWithTextAndLabel({
    label,
    enabled,
    onToggle,
    toggleDisabled,
    redDisabled,
}) {
    if (typeof enabled === 'undefined') {
        return <noscript />;
    }

    const toggleAttributes = {
        isChecked: enabled,
        onToggle,
        isDisabled: toggleDisabled,
    };

    const ToggleComponent = redDisabled ? LockedToggleWithText : NormalToggleWithText;

    return (
        <FormItemSmall>
            <FormLabel>
                {label}
            </FormLabel>
            {typeof enabled !== 'undefined' && <ToggleComponent {...toggleAttributes} />}
        </FormItemSmall>
    );
}

ToggleSwitchWithTextAndLabel.displayName = displayName('Forms/CompositeComponents/ToggleSwitchWithTextAndLabel',);

ToggleSwitchWithTextAndLabel.propTypes = {
    label: PropTypes.string.isRequired,
    enabled: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
    enabledText: PropTypes.string.isRequired,
    disabledText: PropTypes.string,
    redDisabled: PropTypes.bool,
    toggleDisabled: PropTypes.bool,
};

ToggleSwitchWithTextAndLabel.defaultProps = {
    enabled: false,
    redDisabled: false,
    toggleDisabled: false,
    disabledText: '',
};
